import {fromJS, Map} from 'immutable';
import myOverallHighlightsActions from '../../actions/fortnite-game/myOverallHighlights.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {DataItem} from './types';
import {MyOverallHighlight} from '../../types';

export interface MyOverallHighlightsState {
    totals: {
        [MyOverallHighlight.UNIQUE_PLAYERS]: DataItem;
        [MyOverallHighlight.LIFETIME_PLAYS]: DataItem;
        loading: boolean;
        error?: string;
    };
    [MyOverallHighlight.MONTHLY]: DataItem;
    [MyOverallHighlight.WEEKLY]: DataItem;
}

export const DEFAULT_DATA: MyOverallHighlightsState = {
    totals: {
        uniquePlayers: {
            amount: 0,
            trend: 0
        },
        lifetimePlays: {
            amount: 0,
            trend: 0
        },
        loading: true
    },
    monthly: {
        amount: 0,
        trend: 0,
        loading: true
    },
    weekly: {
        amount: 0,
        trend: 0,
        loading: true
    }
};

export const DEFAULT_STATE = fromJS({
    ...DEFAULT_DATA,
    lastFetch: Date.now(),
    error: undefined
});

export const myOverallHighlightsReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {data, error, value} = action.payload || {};

    switch (action.type) {
        case myOverallHighlightsActions.TYPES.GET_HIGHLIGHTS: {
            return state.merge({
                [value]: state.get(value).merge({
                    error: undefined,
                    loading: true
                })
            });
        }

        case myOverallHighlightsActions.TYPES.GET_HIGHLIGHTS_COMPLETE: {
            return state.merge({
                [value]: state.get(value).merge({
                    ...data,
                    loading: false
                }),
                lastFetch: Date.now()
            });
        }

        case myOverallHighlightsActions.TYPES.GET_HIGHLIGHTS_FAILED: {
            return state.merge({
                [value]: state.get(value).merge({
                    error,
                    loading: false
                })
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('myOverallHighlights', myOverallHighlightsReducer);
